/**
 * @generated SignedSource<<0c4a72a34b6ad070015b4070ff6197e1>>
 * @relayHash c6265ea6c0fc1df9c5b6d60954a1cb30
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1096b74b52bce8618235bdd104bb544c5c38d7eb6b94a2e03fb2578f9d0319a0

import type { ConcreteRequest } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type JiraServiceManagementPractice = "CASE_MANAGEMENT" | "CHANGE_MANAGEMENT" | "DEVELOPER_ESCALATION" | "INCIDENT_MANAGEMENT" | "POST_INCIDENT_REVIEW" | "PROBLEM_MANAGEMENT" | "SERVICE_REQUEST" | "%future added value";
export type issueViewSwitchDataFetcherQuery$variables = {
  cloudId: string;
  includeAgenticWorkItemData: boolean;
  includeServicedeskPractice: boolean;
  issueKey: string;
  projectIdOrKey: string;
  skipIssueByKey: boolean;
};
export type issueViewSwitchDataFetcherQuery$data = {
  readonly jira: {
    readonly issueByKey?: {
      readonly key: string;
      readonly project: {
        readonly isAgenticWorkItemViewEnabled?: boolean | null;
        readonly isCreatedFromAgenticTemplate?: boolean | null;
        readonly projectType: JiraProjectType | null;
      } | null;
      readonly servicedeskPractices?: JiraServiceManagementPractice | null;
    } | null;
    readonly userPreferences: {
      readonly isIssueViewWivEnabled: boolean | null;
    } | null;
  } | null;
  readonly jira_projectByIdOrKey: {
    readonly isAgenticWorkItemViewEnabled?: boolean | null;
    readonly isCreatedFromAgenticTemplate?: boolean | null;
    readonly projectType: JiraProjectType | null;
  } | null;
};
export type issueViewSwitchDataFetcherQuery = {
  response: issueViewSwitchDataFetcherQuery$data;
  variables: issueViewSwitchDataFetcherQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeAgenticWorkItemData"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeServicedeskPractice"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectIdOrKey"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipIssueByKey"
},
v6 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v7 = [
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "projectIdOrKey"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v9 = {
  "condition": "includeAgenticWorkItemData",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isCreatedFromAgenticTemplate"
    },
    {
      "kind": "ScalarField",
      "name": "isAgenticWorkItemViewEnabled"
    }
  ]
},
v10 = [
  (v8/*: any*/),
  (v9/*: any*/)
],
v11 = {
  "args": [
    (v6/*: any*/)
  ],
  "concreteType": "JiraUserPreferences",
  "kind": "LinkedField",
  "name": "userPreferences",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isIssueViewWivEnabled"
    }
  ]
},
v12 = [
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "issueKey"
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "key"
},
v14 = {
  "condition": "includeServicedeskPractice",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "servicedeskPractices"
    }
  ]
},
v15 = {
  "kind": "ScalarField",
  "name": "id"
},
v16 = [
  (v8/*: any*/),
  (v9/*: any*/),
  (v15/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "issueViewSwitchDataFetcherQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": (v10/*: any*/)
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          {
            "condition": "skipIssueByKey",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v12/*: any*/),
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issueByKey",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": (v10/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "issueViewSwitchDataFetcherQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": (v16/*: any*/)
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          {
            "condition": "skipIssueByKey",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v12/*: any*/),
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issueByKey",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": (v16/*: any*/)
                  },
                  (v15/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "1096b74b52bce8618235bdd104bb544c5c38d7eb6b94a2e03fb2578f9d0319a0",
    "metadata": {},
    "name": "issueViewSwitchDataFetcherQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "439b74909f89494d1fda25d9a1fa4e4c";

export default node;
